export const initialState = {};

export const getRotations = (state = initialState) =>
  state.browsersource_positioning?.filter((rotation) => rotation.images.length > 0) || [];
